import { useEffect, useState } from "react";
import api from "@/lib/api";

// Cache condivisa a livello di modulo: i contenuti del sito si leggono una sola volta.
let _cache = null;
let _promise = null;

export function primeSiteContent() {
  if (!_promise) {
    _promise = api.get("/site-content")
      .then(({ data }) => { _cache = data; return data; })
      .catch(() => ({}));
  }
  return _promise;
}

export function invalidateSiteContent() {
  _cache = null;
  _promise = null;
}

export function useSiteContent() {
  const [content, setContent] = useState(_cache);
  useEffect(() => {
    let alive = true;
    if (_cache) { setContent(_cache); return; }
    primeSiteContent().then((d) => { if (alive) setContent(d); });
    return () => { alive = false; };
  }, []);
  return content;
}

// Restituisce il valore nella lingua richiesta con fallback a IT e poi al testo i18n.
export function scValue(section, base, lang, fallback = "") {
  if (!section) return fallback;
  const v = section[`${base}_${lang}`] || section[`${base}_it`];
  return v || fallback;
}

// Cache per gruppo per gli elementi CMS ripetibili (header menu, footer, home steps/blocks).
const _cmsCache = {};
const _cmsPromise = {};

export function useCmsItems(group) {
  const [items, setItems] = useState(_cmsCache[group] || []);
  useEffect(() => {
    let alive = true;
    if (_cmsCache[group]) { setItems(_cmsCache[group]); return; }
    if (!_cmsPromise[group]) {
      _cmsPromise[group] = api.get(`/cms/${group}`).then(({ data }) => { _cmsCache[group] = data; return data; }).catch(() => []);
    }
    _cmsPromise[group].then((d) => { if (alive) setItems(d || []); });
    return () => { alive = false; };
  }, [group]);
  return items;
}

export default useSiteContent;
